import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import SVG from "react-inlinesvg";
import NoDataTable from "../../../common/noDataTable";
import Pagination from "@material-ui/lab/Pagination";
import {
  ApiDelete,
  ApiGet,
  ApiPost,
  ApiPut,
  ApiUpload,
} from "../../../helpers/API/ApiData";
import { ErrorToast, SuccessToast } from "../../../helpers/Toast";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import moment from "moment";
import { Dropdown, Form, Modal } from "react-bootstrap";
import Select from "react-select";
import Loader from "../../../media/Loader.gif";
export default function Users() {
  document.title = "Users | Tap Digital";
  const date = new Date();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [totalpage, settotalpage] = useState(0);
  const [currentpage, setcurrentpage] = useState(1);
  const [pagesize, setpagesize] = useState(10);
  const [searching, setsearching] = useState("");
  const [loading, setLoading] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [newData, setNewData] = useState({
    name: "",
    date: moment(date).format("YYYY-MM-DD"),
    country: "",
  });

  const columns = [
    {
      dataField: "name",
      text: "Full Name",
      sort: true,
      formatter: (cell, row) => {
        return <div>{cell || "-"}</div>;
      },
    },
    {
      dataField: "businessName",
      text: "Business Name",
      sort: true,
      formatter: (cell, row) => {
        return <div>{cell || "-"}</div>;
      },
    },
    {
      dataField: "email",
      text: "Email ID",
      sort: true,
      formatter: (cell, row) => {
        return <div>{cell || "-"}</div>;
      },
    },
    {
      dataField: "phoneNumber",
      text: "Phone Number",
      sort: true,
      formatter: (cell, row) => {
        return <div>{cell || "-"}</div>;
      },
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
      formatter: (cell, row) => {
        return <div>{cell || "-"}</div>;
      },
    },
    {
      dataField: "isActive",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex">
              <div class="float-right">
                <div
                  className="px-1 d-flex w_100_7 mx_10 j_center"
                  style={{ width: "80%" }}
                >
                  <label className="switch">
                    <input
                      type="checkbox"
                      id="togBtn"
                      onChange={(e) => {
                        Swal.fire({
                          text: `Are you sure ?`,
                          icon: "warning",
                          showCancelButton: true,
                          showConfirmButton: true,
                          confirmButtonText: `Yes`,
                          confirmButtonColor: "#D72852",
                          cancelButtonColor: "transparent",
                          cancelButtonText: "No, Cancel",
                        }).then((res) => {
                          if (res.isConfirmed) {
                            // onUpdate(row._id);
                          }
                        });
                      }}
                      // name="isFree"
                      // checked={row?.isPostActive}
                    />
                    <div className="slider round">
                      <span className="off"></span>
                      <span className="on"></span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </>
        );
      },
    },

    // {
    //   dataField: "action",
    //   text: "Action",
    //   sort: true,
    //   formatter: (cell, row) => {
    //     return (
    //       <>
    //         <a
    //           title="Edit customer"
    //           className="btn btn-icon btn-light btn-hover-primary btn-sm me-3"
    //           // onClick={() => editBtnClick(row)}
    //         >
    //           <span className="svg-icon svg-icon-md svg-icon-primary">
    //             <SVG
    //               src={toAbsoluteUrl(
    //                 "/media/svg/icons/Communication/Write.svg"
    //               )}
    //             />
    //           </span>
    //         </a>

    //         <a
    //           title="Delete customer"
    //           className="btn btn-icon btn-light btn-hover-danger btn-sm"
    //           onClick={() => {
    //             Swal.fire({
    //               text: `Are you sure you want to Delete ?`,
    //               icon: "warning",
    //               showCancelButton: true,
    //               showConfirmButton: true,
    //               confirmButtonText: `Yes, Delete`,
    //               confirmButtonColor: "#D72852",
    //               cancelButtonColor: "transparent",
    //               cancelButtonText: "No, Cancel",
    //             }).then((res) => {
    //               if (res.isConfirmed) {
    //                 // onDelete(row?._id);
    //               }
    //             });
    //           }}
    //         >
    //           <span className="svg-icon svg-icon-md svg-icon-danger">
    //             <SVG
    //               src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
    //             />
    //           </span>
    //         </a>
    //       </>
    //     );
    //   },
    // },
  ];

  const handleChange = (e) => {
    const { value, name } = e.target;
    setNewData({ ...newData, [name]: value });
  };
  console.log("newData", newData);
  const editBtnClick = (row) => {
    setIsEdit(true);
    setModal(true);
    setNewData({
      id: row?._id,
      name: row?.name,
      date: moment(row?.date).format("YYYY-MM-DD"),
      country: row?.country,
    });
  };
  const onDelete = async (Id) => {
    await ApiDelete(`/delete/calender/${Id}`)
      .then(() => {
        Swal.fire({
          text: "You have Deleted Successfully!!!",
          icon: "success",
          confirmButtonText: "Ok, Got it!",
          confirmButtonColor: "#338DE6",
        });
        fetchData(currentpage, pagesize, searching);
      })
      .catch((err) => ErrorToast(err?.message));
  };
  const onUpdate = async () => {
    let body = {
      id: newData?.id,
      name: newData?.name,
      date: moment(newData?.date).format("MM-DD-YYYY"),
      country: newData?.country,
    };
    console.log("body", body);
    await ApiPut("/update/calender", body)
      .then((res) => {
        SuccessToast(res?.data?.message);
        setModal(false);
        fetchData(currentpage, pagesize, searching);
      })
      .catch((err) => ErrorToast(err?.message));
  };
  const handleSubmit = async () => {
    let body = {
      name: newData?.name,
      date: moment(newData?.date).format("MM-DD-YYYY"),
      country: newData?.country,
    };

    await ApiPost("/add/calender", body)
      .then((res) => {
        SuccessToast(res?.data?.message);
        setModal(false);
        fetchData(currentpage, pagesize, searching);
      })
      .catch((err) => ErrorToast(err?.message));
  };
  const handleonchnagespagination = (e) => {
    setpagesize(e.target.value);
    setcurrentpage(1);
    fetchData(1, parseInt(e.target.value), searching);
  };
  const onPaginationChange = (e, i) => {
    setcurrentpage(i);
    fetchData(i, pagesize, searching);
  };
  const imageChange = async (e) => {
    let file = e.target.files[0];
    let fileURL = URL.createObjectURL(file);
    file.fileURL = fileURL;
    let formData = new FormData();
    formData.append("image", file);
    await ApiUpload("upload/image/profile_image", formData)
      .then((res) => {
        setNewData({ ...newData, thumbnailUrl: res?.data?.data?.image });
      })
      .catch((err) => console.log("res_blob", err));
  };
  const handlesearch = (e) => {
    setsearching(e.target.value);
    fetchData(currentpage, pagesize, e.target.value);
  };
  const fetchData = async (page, limit, search) => {
    setLoading(true);
    let body = { page, limit, search };
    await ApiPost("/user/get", body)
      .then((res) => {
        console.log("/user/get", res?.data?.data);
        setData(res?.data?.data?.response);
        settotalpage(res?.data?.data?.state?.page_limit);
        setLoading(false);
      })
      .catch((err) => ErrorToast(err?.message));
  };

  useEffect(() => {
    fetchData(currentpage, pagesize, searching);
  }, []);
  return (
    <>
      <div className="d-flex justify-content-between mb-4">
        <div className="title">
          <div className="fs-20px fw-bolder">User List</div>
          <div>
            <span
              role="button"
              onClick={() => history.push("/dashboard")}
              className="text-hover-info text-muted"
            >
              Home
            </span>{" "}
            -{" "}
            <span className="text-muted" role="button">
              {" "}
              Users
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column flex-column-fluid h-100" id="kt_content">
        <div class="card card-custom">
          <div class="card-header flex-wrap border-0 pt-6 pb-0 w-100">
            <div class="card-title ">
              {/* <h3 class="card-label">Video Playlist</h3> */}
              <div class="input-icon">
                <input
                  type="text"
                  class="form-control bg-light"
                  name="searchText"
                  placeholder="Search by Name"
                  value={searching}
                  onChange={(e) => handlesearch(e)}
                  id="kt_datatable_search_query"
                />
                <span>
                  <i class="flaticon2-search-1 text-muted"></i>
                </span>
              </div>
            </div>

            <div class="card-toolbar">
              {/* <a
                class="btn btn-dark font-weight-bolder btn-sm ms-4"
                onClick={() => {
                  setIsEdit(false);
                  setModal(true);
                  setNewData({
                    name: "",
                    date: moment(new Date()).format("YYYY-MM-DD"),
                    country: "",
                  });
                }}
              >
                Add User
              </a> */}
            </div>
          </div>
          <div className="card-body mb-5">
            <BootstrapTable
              wrapperClasses="table-responsive"
              headerWrapperClasses="border-0"
              bordered={false}
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              keyField="_id"
              data={data || []}
              columns={columns}
              noDataIndication={() => {
                if (loading) {
                  return (
                    <div className="d-flex justify-content-center">
                      <img src={Loader} alt="" className="h-100px" />
                    </div>
                  );
                } else {
                  return <NoDataTable />;
                }
              }}
            />
            <div class="d-flex justify-content-between  pt-10">
              <div className="my-2">
                <Pagination
                  count={totalpage}
                  page={currentpage}
                  onChange={onPaginationChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination_"
                />
              </div>
              <div class="my-2">
                <div class="d-flex align-items-center pagination-drpdown">
                  <select
                    class="form-control pagination-drpdown1 dropdownPage"
                    id="kt_datatable_search_status"
                    onChange={(e) => handleonchnagespagination(e)}
                    value={pagesize}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={modal} onHide={() => setModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Calender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <Form.Group className="col-md-12">
              <Form.Label>Event Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Event Name"
                label="name"
                id="name"
                required
                name="name"
                onChange={handleChange}
                value={newData.name}
              />
              <span className="errorInput">
                {/* {newData.name?.length > 0 ? "" : errors["name"]} */}
              </span>
            </Form.Group>
            <Form.Group className="col-md-12">
              <Form.Label>Event Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Enter Date"
                label="date"
                id="date"
                required
                name="date"
                role="button"
                onChange={handleChange}
                value={newData.date}
              />
              <span className="errorInput">
                {/* {newData.date?.length > 0 ? "" : errors["date"]} */}
              </span>
            </Form.Group>

            <Form.Group className="col-md-12">
              <Form.Label>Country</Form.Label>
              <Form.Control
                as="select"
                custom
                id="country"
                required
                className="form-control"
                name="country"
                onChange={handleChange}
                value={newData.country}
              >
                <option value="" disabled>
                  Select country
                </option>
                {countryData?.map((v, i) => {
                  return (
                    <>
                      <option value={v?.countryName}>{v?.countryName}</option>
                    </>
                  );
                })}
              </Form.Control>
              {/* <span className="errorInput">
                {data.playlist?.length > 0 ? "" : errors["playlist"]}
              </span> */}
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {isEdit ? (
            <button className="btn btn-color" onClick={onUpdate}>
              Update Changes
            </button>
          ) : (
            <button className="btn btn-color" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
